import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { InoculationPage } from "@/features/fermentation-journal/components/setup";

/** `?start=1` opens the start dialog on arrival (the sidebar's "Running" lands here). */
export const Route = createFileRoute(
  "/fermentations/$group_id/setup/inoculation",
)({
  component: InoculationRoute,
  validateSearch: (search: Record<string, unknown>): { start?: boolean } =>
    search.start === true || search.start === "1" || search.start === 1 || search.start === "true"
      ? { start: true }
      : {},
});

function InoculationRoute() {
  const { group_id } = Route.useParams();
  const { start } = Route.useSearch();
  return (
    <div className="max-w-4xl">
      <InoculationPage
        groupId={group_id as unknown as FermentationGroupId}
        autoOpenStart={start === true}
      />
    </div>
  );
}
